import { useEffect, useState } from "react";

import {
    MenuSettingsDto,
    PaymentSettingsDto,
    PaymentTypeDto,
} from "services/menu/restModels";

type PaymentByType = Record<PaymentTypeDto, PaymentSettingsDto>;

const buildDefault = (type: PaymentTypeDto, currencyId: string): PaymentSettingsDto => ({
    type,
    isEnabled: false,
    serviceFee: {
        isEnabled: false,
        title: {},
        amount: { currencyId, amount: 0 },
    },
    externalId: null,
});

const buildDefaults = (currencyId: string): PaymentByType => ({
    Offline: buildDefault("Offline", currencyId),
    CloudPaymentsCheckout: buildDefault("CloudPaymentsCheckout", currencyId),
    SBPTochka: buildDefault("SBPTochka", currencyId),
});

export const usePaymentsState = (settings: MenuSettingsDto | null, currencyId: string) => {
    const [byType, setByType] = useState<PaymentByType>(() => buildDefaults(currencyId));

    useEffect(() => {
        if (!settings) return;

        const next = buildDefaults(currencyId);
        settings.paymentSettings.forEach((item) => {
            next[item.type] = item;
        });
        setByType(next);
    }, [settings, currencyId]);

    const setEnabled = (type: PaymentTypeDto, isEnabled: boolean) =>
        setByType((prev) => ({ ...prev, [type]: { ...prev[type], isEnabled } }));

    // externalId — идентификатор способа оплаты в iiko, поле видно только при интеграции.
    const setExternalId = (type: PaymentTypeDto, externalId: string) =>
        setByType((prev) => ({ ...prev, [type]: { ...prev[type], externalId } }));

    return {
        paymentByType: byType,
        paymentList: Object.keys(byType).map((key) => byType[key as PaymentTypeDto]),
        setEnabled,
        setExternalId,
    };
};

export type PaymentsState = ReturnType<typeof usePaymentsState>;
